"use client";

import { Facebook, Linkedin, Link2, Twitter } from "lucide-react";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ShareButtons() {
  const [copied, setCopied] = useState(false);
  const [url, setUrl] = useState("");
  const pathname = usePathname();

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const shareFacebook = () => {
    window.open(

      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,

      "_blank"

    );

  };



  const shareX = () => {

    window.open(

      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,

      "_blank"

    );

  };



  const shareLinkedIn = () => {

    window.open(

      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,

      "_blank"

    );

  };



  const copyLink = async () => {

    await navigator.clipboard.writeText(url);

    setCopied(true);



    setTimeout(() => setCopied(false), 2000);

  };



  return (

    <div className="flex gap-4">



      <button

        onClick={shareFacebook}

        aria-label="Share on Facebook"

        className="p-3 rounded-full bg-slate-50 hover:bg-blue-50 text-slate-400 hover:text-blue-600"

      >

        <Facebook className="w-5 h-5" />

      </button>



      <button

        onClick={shareX}

        aria-label="Share on X (Twitter)"

        className="p-3 rounded-full bg-slate-50 hover:bg-blue-50 text-slate-400 hover:text-blue-600"

      >

        <Twitter className="w-5 h-5" />

      </button>



      <button

        onClick={shareLinkedIn}

        aria-label="Share on LinkedIn"

        className="p-3 rounded-full bg-slate-50 hover:bg-blue-50 text-slate-400 hover:text-blue-600"

      >

        <Linkedin className="w-5 h-5" />

      </button>



      <button

        onClick={copyLink}

        aria-label="Copy link to clipboard"

        className="p-3 rounded-full bg-slate-50 hover:bg-blue-50 text-slate-400 hover:text-blue-600"

      >

        <Link2 className="w-5 h-5" />

      </button>



      {copied && (

        <span className="text-xs text-green-500">Copied</span>

      )}

    </div>

  );

}